module.exports = __webpack_public_path__ + "static/media/container-004.6a560cd1.jpg";